const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHexagonBorderDashedWhiteSmall(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 101.859,
    height: 117.265,
    viewBox: "0 0 26.95 31.026",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "m88.014 110.327-13.175 7.606-13.175-7.606V95.114l13.175-7.607 13.175 7.607z",
    style: {
      opacity: 1,
      fill: "none",
      fillOpacity: 1,
      stroke: "#fff",
      strokeWidth: 0.4,
      strokeLinecap: "butt",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "1.2,1.19999999999999996",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "fill markers stroke"
    },
    transform: "translate(-61.364 -87.207)"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHexagonBorderDashedWhiteSmall);
export default __webpack_public_path__ + "static/media/hexagon_border_dashed_white_small.fb2c89a8cfe9ed3aaa8dd4dbeaa472c8.svg";
export { ForwardRef as ReactComponent };